@if(!option.declineReasons?.length) {
  <mat-dialog-content>
    <mat-icon (click)="closeModal()" class="close tw-cursor-pointer tw-m-6 tw-me-0" aria-hidden="false" mat-dialog-close>close</mat-icon>
    <div class="dialog-header tw-row-auto">
      <h1 mat-dialog-title class="px-0 mb-0">Why did the borrower decline this option? (Select all that apply)</h1>
    </div>
    <div class="tw-text-base d-flex">
      @if(isLoading$ | async) {
        <div class="tw-m-4 d-flex justify-content-center tw-w-full tw-my-8">
          <mat-spinner diameter="24"></mat-spinner>
          <div class="tw-ml-2 tw-text-black">Loading...</div>
        </div>
      } @else {
        <div class="details tw-flex-1">
          <div class="tw-grid py-2 tw-flex tw-flex-row">
            @for (reason of activeReasons$ | async; track reason.id) {
              <mat-checkbox
                (change)="onReasonSelected(reason, $event.checked)"
                class="tw-row-auto"
              >
                {{reason.reason}}
              </mat-checkbox>
            }
          </div>
          @if(otherReason$ | async) {
            <p class="tw-row-auto py-2">Any other reasons?</p>
            <textarea
              [(ngModel)]="otherReasonValue"
              id="other-decline"
              class="tw-row-auto decline-textbox p-3"
              matInput
              placeholder="Provide their feedback here">
            </textarea>
          }
        </div>
      }
    </div>
  </mat-dialog-content>
} @else {
  <mat-dialog-content>
    <mat-icon (click)="closeModal()" class="close tw-cursor-pointer tw-m-6 tw-me-0" aria-hidden="false" mat-dialog-close>close</mat-icon>
    <div class="dialog-header tw-row-auto">
      <h1 mat-dialog-title class="px-0 mb-0">Are you sure you want to un-decline this option? You will remove any existing decline reasons.</h1>
    </div>
  </mat-dialog-content>
}
<mat-dialog-actions align="end">
  <button
    class="btn btn-default tw-mr-2"
    (click)="closeModal()"
  >
    Cancel
  </button>
  <button
    class="btn btn-primary"
    (click)="onSave()"
    [disabled]="!option.declineReasons?.length && !otherReasonValue.trim() && !(selectedReasons$ | async)?.length"
  >
    @if (!option.declineReasons?.length) {
      Decline
    } @else {
      Un-decline
    }
  </button>
</mat-dialog-actions>
